import breakpoints from './breakpoints';
import colors from './colors';
import font from './fonts';
import media from './media';
import promoBreakpoints from './promoBreakpoints';
import promoColors from './promoColors';
import promoMedia from './promoMedia';
import zIndex from './zIndex';

const theme = {
    font,
    colors,
    breakpoints,
    mediaQueries: media,
    zIndex,
    promoColors,
    promoBreakpoints,
    promoMediaQueries: promoMedia,
};

export default theme;
